export default function Footer() {
  return (
    <span
      style={{ letterSpacing: "3px", color: "#cacaca" }}
    >{`World Cup ${new Date().getFullYear()}`}</span>
  );
}
